import React from 'react'

export const PageTitle = ({ title }) => {
  return <h4 className="ul-heading-4">{title}</h4>
}

export default PageTitle
